// extracted by mini-css-extract-plugin
module.exports = {"container":"tenants_container__fMNYu","detailHeader":"tenants_detailHeader__3CAA_","settingIcon":"tenants_settingIcon__34QHm","filter":"tenants_filter__2Bbfu"};